import http from "@/http";
//### 景区列表
// https://zs.xzu.ink/api/scenic/list
export const getScenic = {
  p: "/api/scenic/list",
  r: data => {
    return http({
      url: "/api/scenic/list",
      method: "post",
      data
    });
  }
};
//### 景区详细信息
// https://zs.xzu.ink/api/scenic/details/1036
export const getScenicInfo = {
  p: "/api/scenic/details",
  r: data => {
    return http({
      url: "/api/scenic/details/" + data.id,
      method: "get"
      // data
    });
  }
};
// ### 添加景区
// https://zs.xzu.ink/api/scenic/add
export const addScenic = {
  p: "/api/scenic/add",
  r: data => {
    return http({
      url: "/api/scenic/add",
      method: "post",
      data
    });
  }
};
//  ### 修改景区
// https://zs.xzu.ink/api/scenic/edit_scenic
export const editScenic = {
  p: "/api/scenic/edit_scenic",
  r: data => {
    return http({
      url: "/api/scenic/edit_scenic",
      method: "post",
      data
    });
  }
};
//  ### 删除景区
// https://zs.xzu.ink/api/scenic/delete
export const deleteScenic = {
  p: "/api/scenic/delete",
  r: data => {
    return http({
      url: "/api/scenic/delete",
      method: "post",
      data
    });
  }
};
// ### 设置景区基础信息
// https://zs.xzu.ink/api/scenic/add_info
export const addScenicInfo = {
  p: "/api/scenic/add_info",
  r: data => {
    return http({
      url: "/api/scenic/add_info",
      method: "post",
      data
    });
  }
};
// ### 获取景区门票
export const getTicketSelect = {
  p: "/api/scenic/ticket_select",
  r: data => {
    return http({
      url: "/api/scenic/ticket_select",
      method: "post",
      data
    });
  }
};